/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDeviceHealth, IDeviceHealthState } from '../state/device-health.state';

export const getDeviceHealthState = createFeatureSelector<IDeviceHealthState>('deviceHealth');

export const getAllDevicesHealth = createSelector(
  getDeviceHealthState,
  (state: IDeviceHealthState): IDeviceHealth[] | null => state.devices ?? null
);

export const getDevicehealthDetails = createSelector(getDeviceHealthState, (state: IDeviceHealthState): IDeviceHealth => {
  if (state.devices) {
    return state.devices.find(x => x.vehicleId == state.selectedVehicleId);
  }
  return null;
});

export const getSelectedVehicleIdDeviceHealth = createSelector(
  getDeviceHealthState,
  (state: IDeviceHealthState): string => state.selectedVehicleId ?? ''
);

export const getAllDevicesHealthLoading = createSelector(
  getDeviceHealthState,
  (state: IDeviceHealthState): boolean => state.devicesHealthLoading ?? false
);

export const getCountOfAllDeviceIssues = createSelector(
  getDeviceHealthState,
  (state: IDeviceHealthState): number => state.totalDeviceIssues ?? 0
);
